import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Space from 'components/generic/Space.component';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToLocalPath from 'utils/converters/any/fromAnyToLocalPath.util';

import CN from './AllowedMenuItem.module.scss';

const AllowedMenuItem = ({ title, children, onClick, icon, to }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="AllowedMenuItem"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <NavLink to={fromAnyToLocalPath(to)} activeClassName="active" onClick={onClick} className={CN.item}>
        <img src={icon} alt={title} className={CN.menuIcon} />
        <Space>{title}</Space>
        {children}
      </NavLink>
    </div>
  );
};

export default AllowedMenuItem;
